var _excluded = ["actionColumn", "customIcon", "customImage", "dataColumns", "expandButtonProps", "globalColumnSettings", "id", "nameColumn", "parentItem", "selectableCheckbox", "selected", "size", "subItemIds"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useState } from 'react';
import * as IconSet from "../../../../icons/index.js";
import Button from "../../../basic/Button/Button.js";
import Icon from "../../../basic/Icon/Icon.js";
import Layout from "../../../basic/Layout/Layout.js";
import Checkbox from "../../../form/Checkbox/Checkbox.js";
import { ActionColumn, DataColumn, DataColumnContainer, NameColumn, StyledTableItem, TableItemCheckbox, TableItemCustomIcon, TableItemCustomImage, TableItemCustomImageContainer, TableItemExpandButton } from "../styledComponents.js";
import TableItemName from "./TableItemName.js";
var isColumnElement = element => {
  return typeof element === 'object' && /*#__PURE__*/React.isValidElement(element);
};

/* Table item component */

var TableItem = _ref => {
  var {
      actionColumn,
      customIcon,
      customImage,
      dataColumns,
      expandButtonProps,
      globalColumnSettings = {
        action: {},
        dataColumns: [],
        name: {}
      },
      id,
      nameColumn,
      parentItem,
      selectableCheckbox,
      selected,
      size = 'medium',
      subItemIds
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var {
    action: actionColumnSettings,
    dataColumns: dataColumnSettings,
    name: nameColumnSettings
  } = globalColumnSettings || {};
  var {
    align: actionColumnAlign = 'right',
    minWidth: actionColumnMinWidth
  } = actionColumnSettings || {};
  var {
    minWidth: nameColumnMinWidth
  } = nameColumnSettings;
  var [isExpanded, setIsExpanded] = useState(false);
  var tempId = id || "table-item-1";

  // Component proper
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledTableItem, _extends({
    "data-parent-id": parentItem || null,
    expanded: isExpanded,
    globalColumnSettings: globalColumnSettings,
    id: tempId,
    key: tempId,
    selectableCheckbox: selectableCheckbox,
    selected: selected,
    size: size
  }, props), nameColumnSettings && nameColumn && /*#__PURE__*/React.createElement(NameColumn, {
    minWidth: nameColumnMinWidth,
    hasParentItem: !!parentItem,
    size: size
  }, subItemIds && /*#__PURE__*/React.createElement(TableItemExpandButton, {
    expanded: isExpanded,
    size: size
  }, /*#__PURE__*/React.createElement(Button, _extends({
    "aria-controls": subItemIds,
    "aria-expanded": isExpanded,
    icon: IconSet.ChevronDown,
    size: "small",
    variant: "text"
  }, expandButtonProps, {
    onClick: event => {
      var _expandButtonProps$on;
      setIsExpanded(!isExpanded);
      expandButtonProps === null || expandButtonProps === void 0 || (_expandButtonProps$on = expandButtonProps.onClick) === null || _expandButtonProps$on === void 0 || _expandButtonProps$on.call(expandButtonProps, event);
    }
  }))), selectableCheckbox && /*#__PURE__*/React.createElement(TableItemCheckbox, {
    size: size
  }, /*#__PURE__*/React.createElement(Checkbox, _extends({
    fieldSize: size === 'small' ? 'small' : 'medium',
    "aria-labelledby": "".concat(tempId, "-name")
  }, selectableCheckbox))), customImage && /*#__PURE__*/React.createElement(TableItemCustomImageContainer, {
    size: size
  }, typeof customImage === 'string' ? /*#__PURE__*/React.createElement(TableItemCustomImage, {
    size: size,
    style: {
      backgroundImage: "url(".concat(customImage, ")")
    }
  }) : customImage), customIcon && /*#__PURE__*/React.createElement(TableItemCustomIcon, {
    size: size
  }, /*#__PURE__*/React.createElement(Icon, _extends({
    size: customIcon.size || 18
  }, customIcon))), /*#__PURE__*/React.createElement(TableItemName, _extends({
    parentId: tempId,
    size: size
  }, nameColumn))), /*#__PURE__*/React.createElement(DataColumnContainer, {
    parentItem: parentItem,
    size: size
  }, dataColumnSettings && dataColumns && /*#__PURE__*/React.createElement("div", null, dataColumns.map((column, i) => {
    if (!isColumnElement(column)) return;
    if (!dataColumnSettings || !dataColumnSettings[i]) {
      console.error('[Table Component] Table and Table.Item must have a corresponding number of data columns.');
    }
    var {
      align,
      minWidth
    } = dataColumnSettings[i] || {};
    return /*#__PURE__*/React.createElement(DataColumn, {
      align: align,
      key: "data-column-".concat(i + 1),
      minWidth: minWidth,
      size: size
    }, /*#__PURE__*/React.cloneElement(column, {
      size
    }));
  }))), actionColumnSettings && actionColumn && /*#__PURE__*/React.createElement(ActionColumn, {
    minWidth: actionColumnMinWidth,
    size: size
  }, /*#__PURE__*/React.createElement(Layout, {
    align: actionColumnAlign,
    gap: "var(--spacing-1)",
    valign: "top"
  }, actionColumn))));
};
export default TableItem;